export default "__VITE_ASSET__BkUlLkxh__"